/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LineChart } from "../models/http/charts/line-chart/line-chart.model";
import { MapChart } from "../models/http/charts/map-chart/map-chart.model";
import { CarbonIntensitySummary } from "../models/http/what-if/carbon-intensity/carbon-intensity-summary.model";
import { WhatIfCarbonIntensityHttpService } from "./http/what-if-carbon-intensity-http.service";
import { ChartResponse } from "../models/ui/charts.model";

@Injectable({
	providedIn: "root"
})
export class WhatIfCarbonIntensityService {
	constructor(private _whatIfCarbonIntensityHttpService: WhatIfCarbonIntensityHttpService) {}

	/**
	 * Retrieves all carbon intensity data.
	 *
	 * @returns An Observable that emits an object containing an array of CarbonIntensityData.
	 */
	public getAllCarbonIntensityData(): Observable<ChartResponse<MapChart>> {
		return this._whatIfCarbonIntensityHttpService.getAllCarbonIntensity();
	}

	/**
	 * Retrieves the monthly average carbon intensity for a specified region.
	 *
	 * @param {string} region - The name of the region for which to get the carbon intensity monthly average.
	 * @returns An observable containing the monthly average carbon intensity data.
	 */
	public getMonthlyAverageByRegion(region: string): Observable<CarbonIntensitySummary> {
		return this._whatIfCarbonIntensityHttpService.getMonthlyAverageByRegion(region);
	}

	/**
	 * Retrieves the hourly average carbon intensity for a specified region.
	 *
	 * @param {string} region - The region for which to get the carbon intensity hourly average.
	 * @returns An observable containing the line chart data for the region's carbon intensity hourly average.
	 */
	public getHourlyAverageByRegion(region: string): Observable<ChartResponse<LineChart>> {
		return this._whatIfCarbonIntensityHttpService.getHourlyAverageByRegion(region);
	}
}
